import React from 'react'
import {
    TableRow,
    TableCell,
} from '@mui/material';
import ForecastMonthStateCell from './ForecastMonthStateCell';

const ForecastMonthStateRows = ({ headerRows, data }) => {

    if (!headerRows || !data) {
        return null;
    }

    return data && data.map((hq, hqIndex) => {
        return hq?.children.map((dp, dpIndex) => {
            return (
                <TableRow key={dpIndex}>
                    {dpIndex === 0 && dp.id !== 'total' && <TableCell rowSpan={hq.rowSpan} sx={{ width: '115px' }}>{hq.name}</TableCell>}
                    <TableCell sx={{ width: '100px' }} align={(dp.id === 'total') ? 'right' : 'left'} colSpan={(dp.id === 'total') ? 2 : 1}>{dp.name}</TableCell>
                    <ForecastMonthStateCell headerRows={headerRows} data={dp} />
                </TableRow>)

        })
    })
}

export default ForecastMonthStateRows